module.exports = __webpack_public_path__ + "img/logo.38803e42.png";